export default __webpack_public_path__ + "static/media/1_EPpISNyCRRSBsnanPGg-Ag.61981ca1.jpeg";